// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 

// import nhb1 from "../../assets/three-30-11-25.png";
// import nhb2 from "../../assets/four-30-11-25.png";
// import nhb3 from "../../assets/capital-investment-30-11-25.png";
// import nhb4 from "../../assets/capital-investment-3.png";
// import nhb5 from "../../assets/capital-investment-4.png";

// export default function NHM() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Capital Investment subsidy scheme for construction/expansion/ modernization of cold storage and storages for Horticulture Produce from NHB & NHM</h1>

//                                   <p>Most of our horticultural produce like fruits, vegetables, Red Chillies, Turmeric, Tamarind and other Horticulture produce, are wasted, mainly on account of poor cold storage and other storage facilities. When it comes to, a capital investment subsidy scheme for construction/expansion/modernisation of cold storage and storages for horticulture produce has been introduced. It might help in minimising post-harvest losses being suffered by farmers, particularly small and marginal farmers. The scheme is implemented by National Horticulture Board (NHB), Ministry of Agriculture. during this article, we glance at the Capital Investment Subsidy Scheme for Horticulture intimately.</p>
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Objectives of the Scheme</h2>
//                                   <p>The main objectives of the Capital Investment Subsidy Scheme for Horticulture is given below:</p>

//                                   <ul>
//                                       <li>To promote setting up of cold storages in the country for reducing post-harvest losses</li>
//                                   </ul>

//                                   <h2>Capacity and Pattern of Assistance: -</h2>
//                                   <p>The assistance will be given as subsidy @35% of the Capital cost of project in general areas and 50% in case of NE, Hilly states & Scheduled Areas for a storage Capacity above 5000 MT upto 10000 MT.</p>
//                                   <p>In case of North East States, projects with a capacity of 1000 MT or above are also eligible for application and consideration.</p>

//                                 <h2>Eligible Firms are:</h2>
//                                 <p>Unless otherwise specified, organizations/promoters, such as Association of Growers, Individuals, group of farmer growers/consumers, Farmers Producer Organizations (FPOs,) Partnership/Proprietary Firms, Self Help groups (SHGs), NGOs, Companies, Corporations, Cooperatives, Co-operative Marketing Federations, Agricultural Produce Marketing Committees, Marketing Boards/Committees, Municipal Corporations/ Committees, AgroIndustries Corporations, SAU’s and other concerned R&D organizations are eligible to get assistance under all the NHB schemes.</p>

//                                 <h2>Components</h2>
//                                 <p>Credit linked projects relating to Cold Storages including Controlled Atmosphere (CA) and their Modernization are eligible for assistance under this component.</p>
//                                 <h2>Subsidy Cost Norms:</h2>

//                                   <img src={nhb1} alt="Subsidy Cost Norms" className="img-fluid b-block mx-auto mb-3" />
//                                 <img src={nhb2} alt="Subsidy Cost Norms" className="img-fluid b-block mx-auto mb-3" />
//                                 <img src={nhb3} alt="Subsidy Cost Norms" className="img-fluid b-block mx-auto mb-3" />

//                                 <h2>1. Technology Add on for CA and Modernization (Subsidy to maximum of Rs. 50 crores for CA equipment and Rs. 2.50 crores modernization).</h2>

//                                 <img src={nhb4} alt="Subsidy Cost Norms" className="img-fluid b-block mx-auto mb-3" />
//                                 <img src={nhb5} alt="Subsidy Cost Norms" className="img-fluid b-block mx-auto mb-3" />

//                                 <p>Want to know more details about the scheme details. Please Contact Us.</p>  
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// };


import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";

export default function NHM() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Capital Investment Subsidy for Cold Storage & Horticulture Infrastructure
              </h1>

              <p>
                The Government of India provides capital subsidies through NHB & NHM
                to support the development of modern cold storage infrastructure,
                reducing post-harvest losses and improving supply chain efficiency.
              </p>

              <p>
                These schemes help farmers and businesses improve storage,
                preserve quality, and increase profitability.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Develop modern cold storage infrastructure</li>
            <li><FaCheckCircle /> Reduce post-harvest losses</li>
            <li><FaCheckCircle /> Improve storage and supply chain efficiency</li>
            <li><FaCheckCircle /> Support farmers and agri-businesses</li>
            <li><FaCheckCircle /> Promote value addition</li>
          </ul>

          {/* SUBSIDY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Subsidy Pattern
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 35% subsidy (general areas)</li>
            <li><FaCheckCircle /> 50% subsidy (NE & special areas)</li>
            <li><FaCheckCircle /> Credit-linked back-ended subsidy</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligible Beneficiaries
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Entrepreneurs & companies</li>
            <li><FaCheckCircle /> Farmer groups & FPOs</li>
            <li><FaCheckCircle /> SHGs & NGOs</li>
            <li><FaCheckCircle /> Cooperatives & institutions</li>
            <li><FaCheckCircle /> Government bodies</li>
          </ul>

          {/* COMPONENTS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Project Components
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Cold storage chambers</li>
            <li><FaCheckCircle /> CA storage systems</li>
            <li><FaCheckCircle /> Refrigeration & insulation</li>
            <li><FaCheckCircle /> Electrical & backup systems</li>
            <li><FaCheckCircle /> Pre-cooling & grading units</li>
          </ul>

          {/* COST */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Cost Coverage
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Civil construction & structures</li>
            <li><FaCheckCircle /> Refrigeration systems</li>
            <li><FaCheckCircle /> Insulation & safety systems</li>
            <li><FaCheckCircle /> Utilities (power, DG sets)</li>
          </ul>

          {/* TECH */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Technology Add-ons
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Controlled Atmosphere (CA)</li>
            <li><FaCheckCircle /> Automation & PLC systems</li>
            <li><FaCheckCircle /> Reefer transport</li>
            <li><FaCheckCircle /> Energy-efficient solutions</li>
          </ul>

          {/* INFRA */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Additional Infrastructure
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Packaging & processing units</li>
            <li><FaCheckCircle /> Warehouse integration</li>
            <li><FaCheckCircle /> Material handling systems</li>
            <li><FaCheckCircle /> Retail cold chain solutions</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including DPR preparation,
            eligibility assessment, documentation, bank coordination, and subsidy
            processing to ensure smooth project execution.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Strong subsidy expertise</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Customized project solutions</li>
            <li><FaCheckCircle /> Complete compliance support</li>
            <li><FaCheckCircle /> Transparent process</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}